import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { resetALL } from "../../../../../../../../../.globals/redux/actions";
import { endpoints } from "../../../../../../../../../core/defaultValues";
import { clientQuery } from "../../../../../../../../../core/data/GraphQLApi";
import { ExceptionManager } from "../../../../../../../../../core/logManager";

const INIT_STATE = {
    loading: false,
    historyLogs: [],
    workOrderStatus: []
};

const route = "modules/workOrders/views/trackerTab/modals/createEditWorkOrder/views/historyLogs/redux/slice";


export const workOrdersSettingsSearchHistoryLogs = createAsyncThunk(
    "workOrders/historyLogs/searchHistoryLogs",
    async ({ workOrderId }, { rejectWithValue }) => {
        try {
            const response = await clientQuery(
                `
                    query ($conditions: [WorkOrderLogSearchInput], $sort: [WorkOrderLogSortInput], $limit: Int, $offset: Int) {
                        data: searchWorkOrderLogs(
                            conditions: $conditions
                            sort: $sort
                            limit: $limit
                            offset: $offset
                        ) {
                            total
                            items {
                                id
                                workOrderId
                                logType
                                jsonDetails
                                updatedBy
                                createdOn
                                updatedOn
                                updatedBy
                                createdBy
                                nameCreatedBy {
                                    id
                                    name
                                }
                                customer {
                                    id
                                    name
                                }
                                driver {
                                    id
                                    name
                                }
                                workOrderType {
                                    id
                                    name
                                }
                                customerLocation {
                                    id
                                    name
                                    address
                                }
                                customerContact {
                                    id
                                    name
                                    phone
                                    email
                                }
                                status {
                                    id
                                    name
                                }
                            }
                        }
                    }
                `,
                {
                    conditions: [
                        {
                            fields: ["logType"],
                            terms: ["history", "statusChange", "gpsEvent"],
                        },
                        {
                            fields: ["workOrderId"],
                            terms: [workOrderId],
                        }
                    ],
                    sort: {
                        "field": "createdOn",
                        "order": "DESC"
                    }
                },
                endpoints.GRAPHQL_GENERAL_V2
            );

            return response?.data?.items || []

        } catch (exc) {
            ExceptionManager(exc, route, "searchWorkOrderLogs");
            return rejectWithValue(exc);
        }
    }
);

export const workOrdersSettingsSearchStatuses = createAsyncThunk(
    "workOrders/workOrdersSettingsSearchWorkOrderTypes/searchWorkOrderStatuses",
    async ({ }, { rejectWithValue }) => {
        try {
            const response = await clientQuery(
                `
                    query ($conditions: [WorkOrderStatusSearchInput], $sort: [WorkOrderStatusSortInput], $limit: Int, $offset: Int) {
                        data: searchWorkOrderStatuses(
                            conditions: $conditions
                            sort: $sort
                            limit: $limit
                            offset: $offset
                        ) {
                            total
                            items {
                                id
                                name
                                color
                            }
                        }
                    }
                `,
                {
                    conditions: [],
                    sort: {
                        "field": "name",
                        "order": "ASC"
                    }
                },
                endpoints.GRAPHQL_GENERAL_V2
            );

            return response?.data?.items || []

        } catch (exc) {
            ExceptionManager(exc, route, "searchWorkOrderTypes");
            return rejectWithValue(exc);
        }
    }
);

const workOrdersHistoryLogsWorkOrderRedux = createSlice({
    name: "workOrders/historyLogs",
    initialState: INIT_STATE,
    reducers: {
        resetWorkOrderHistoryLogs(state, action) {
            return action.payload
                ? { ...state, ...action.payload }
                : { ...INIT_STATE };
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        //workOrdersSettingsSearchHistoryLogs
        builder.addCase(workOrdersSettingsSearchHistoryLogs.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(workOrdersSettingsSearchHistoryLogs.fulfilled, (state, action) => {
            state.loading = false;
            state.historyLogs = action.payload;
        });
        builder.addCase(workOrdersSettingsSearchHistoryLogs.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        //workOrdersSettingsSearchStatuses
        builder.addCase(workOrdersSettingsSearchStatuses.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(workOrdersSettingsSearchStatuses.fulfilled, (state, action) => {
            state.loading = false;
            state.workOrderStatus = action.payload;
        });
        builder.addCase(workOrdersSettingsSearchStatuses.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = workOrdersHistoryLogsWorkOrderRedux;

// Extract and export each action creator by name
export const {
    resetWorkOrderHistoryLogs
} = actions;

// Export the reducer, either as a default or named export
export default reducer;
